import { render, staticRenderFns } from "./serviceDetailModal.vue?vue&type=template&id=88d5cabc&"
import script from "./serviceDetailModal.vue?vue&type=script&lang=js&"
export * from "./serviceDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports